import { render, staticRenderFns } from "./shopsalesAnalysis.vue?vue&type=template&id=19fb34bc&scoped=true"
import script from "./shopsalesAnalysis.vue?vue&type=script&lang=ts"
export * from "./shopsalesAnalysis.vue?vue&type=script&lang=ts"
import style0 from "./shopsalesAnalysis.vue?vue&type=style&index=0&id=19fb34bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fb34bc",
  null
  
)

export default component.exports